
import { defineComponent, PropType, computed, toRefs, ref, reactive, watch } from "vue";

import {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    vLoading,
    ElMessage,
    ElSelect,
    ElOption,
    ElSwitch,
} from "element-plus";

import { doEditGenre, EditGenreParam, getGenreStyleInfo } from "@/services";
import { GenreStyleModel, GenreStyleId } from "@/typings";
import { useRouter } from "vue-router";
import { useUserInfo } from "@/store";
import { StyleInput } from "@/components/common";

export default defineComponent({
    directives: {
        vLoading,
    },
    components: {
        ElDialog,
        ElForm,
        ElFormItem,
        ElInput,
        ElButton,
        ElSelect,
        ElOption,
        StyleInput,
        ElSwitch,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String as unknown as PropType<GenreStyleId>,
            required: true,
        },
        info: {
            type: Object as unknown as PropType<GenreStyleModel>,
            required: false,
        },
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        "update:visible"(val: boolean) {
            return true;
        },
        change() {
            return true;
        },
    },
    setup(props, { emit }) {
        const { visible, id, info } = toRefs(props);

        const userInfo = useUserInfo();

        const dialogFormVisible = computed({
            get: () => visible.value,
            set: (val) => emit("update:visible", val),
        });

        const dialogTitle = ref("");
        const everEdited = ref(false);

        const onChangeProfile = () => {
            everEdited.value = true;
        };

        const loadings = reactive({
            formLoading: false,
        });

        const formEditStyle = reactive<EditGenreParam>({
            profile: "",
            origins: [],
            name: "",
            name_alt: "",
            show_in_list: true,
            type: {
                index: 3,
                name: 'Style'
            },
            parents: [],
        });

        const initFormData = (infoData: GenreStyleModel) => {
            dialogTitle.value = infoData.name;
            Object.assign(formEditStyle, {
                name: infoData.name,
                name_alt: infoData.name_alt,
                type: infoData.type,
                profile: infoData.profile,
                origins: infoData.origins,
                parents: infoData.parents,
                show_in_list: infoData.show_in_list,
            });
            formEditStyle.origins = JSON.parse(
                JSON.stringify(
                    infoData!.origins.map((item) => {
                        return item._id;
                    }),
                ),
            );
            formEditStyle.parents = JSON.parse(
                JSON.stringify(
                    infoData!.parents.map((item) => {
                        return item._id;
                    }),
                ),
            );
        };

        const refreshData = () => {
            if (info.value && info.value._id) {
                initFormData(info.value);
                return;
            }
            loadings.formLoading = true;
            getGenreStyleInfo(id.value as string).then((json) => {
                initFormData(json.data.info);
                loadings.formLoading = false;
            });
        };
        watch(() => {
            return visible.value;
        }, refreshData, {
            immediate: false,
        });


        const doConfirmEdit = () => {
            if (!everEdited.value) {
                ElMessage.warning("数据无变化");
                return;
            }

            doEditGenre(id.value, formEditStyle)
                .then((json) => {
                    emit("change");
                    ElMessage.success("感谢您的编辑");
                    dialogFormVisible.value = false;
                })
                .catch((json) => {
                    ElMessage.error(json.data.msg);
                });
        };

        const onChooseStyle = (key: "parents" | "origins", styles: any) => {
            formEditStyle[key] = styles;
            everEdited.value = true;
        };

        return {
            dialogFormVisible,
            dialogTitle,
            userInfo,
            loadings,
            formEditStyle,
            refreshData,
            onChooseStyle,
            doConfirmEdit,
            onChangeProfile,
        };
    },
});
